import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import {
  IDataSourceRequest,
  IDataSourceResult,
  Citizen,
  CreateOrUpdateCitizen,
  ChangeCompoundStatus,
  ProviderCitizens,
} from '../models';
import { HelperService } from './helper.service';

@Injectable({ providedIn: 'root' })
export class CitizenService {
  url = '/citizens';
  request: IDataSourceRequest;
  providerCitizensRequest: IDataSourceRequest;
  compoundCitizenRequest: IDataSourceRequest;

  constructor(private apiService: ApiService, private helperService: HelperService) {
    this.request = Object.assign({}, this.helperService.request);
    this.providerCitizensRequest = Object.assign({}, this.helperService.request);
    this.compoundCitizenRequest = Object.assign({}, this.helperService.request);
  }

  get(): Observable<IDataSourceResult<Citizen>> {
    return this.apiService.post(`${this.url}/search`, this.request).pipe(map(data => data.data));
  }

  getById(id: number): Observable<Citizen> {
    return this.apiService.get(`${this.url}/${id}`).pipe(map(data => data.data));
  }

  create(model: CreateOrUpdateCitizen): Observable<void> {
    return this.apiService.post(this.url, model).pipe(map(data => data.data));
  }

  update(id: number, model: CreateOrUpdateCitizen): Observable<void> {
    return this.apiService.put(this.url, id.toString(), model).pipe(map(data => data.data));
  }

  delete(id: number): Observable<void> {
    return this.apiService.delete(`${this.url}/${id}`).pipe(map(data => data.data));
  }

  getCompoundCitizen(): Observable<IDataSourceResult<Citizen>> {
    return this.apiService
      .post(`${this.url}/search-compounds`, this.compoundCitizenRequest)
      .pipe(map(data => data.data));
  }

  changeCompoundStatus(id: number, model: ChangeCompoundStatus): Observable<void> {
    return this.apiService
      .put(`${this.url}/change-compound-status`, id.toString(), model)
      .pipe(map(data => data.data));
  }

  getCountOfPendingCitizensInCompound(): Observable<number> {
    return this.apiService
      .get(`${this.url}/get-count-of-pending-citizens-in-compound`)
      .pipe(map(data => data.data));
  }

  exportCitizensExcel(): Observable<any> {
    return this.apiService
      .postWithReponseArrayBuffer(`${this.url}/export-citizens-excel/`, this.request)
      .pipe(map(data => data));
  }

  getProviderCitizens(): Observable<IDataSourceResult<ProviderCitizens>> {
    return this.apiService
      .post(`${this.url}/get-provider-citizens`, this.providerCitizensRequest)
      .pipe(map(data => data.data));
  }

  exportProviderCitizensExcel(): Observable<any> {
    return this.apiService
      .postWithReponseArrayBuffer(
        `${this.url}/export-provider-citizens-excel/`,
        this.providerCitizensRequest
      )
      .pipe(map(data => data));
  }

  exportCompoundCitizensExcel(): Observable<any> {
    return this.apiService
      .postWithReponseArrayBuffer(
        `${this.url}/export-compound-citizens-excel/`,
        this.compoundCitizenRequest
      )
      .pipe(map(data => data));
  }
}
